import createAPIRequest from "../helpers/createAPIRequest";
import store from "../store/index";
//----------------------
// edit combat reaction
//----------------------
export default async function useEditCombatReaction(this_reaction) {
  return new Promise((resolve, reject) => {
    //--------------
    // access store
    //--------------
    const this_store = store;
    //--------------------
    // set api call parms
    //--------------------
    let parm_slug = "";

    if (this_reaction.slug != "") {
      parm_slug = this_reaction.slug;
    }

    let request_parms = {
      endpoint: "api/v1/combat-reactions/",
      slug: parm_slug,
    };
    //--------------------
    // create api request
    //--------------------
    let request = createAPIRequest(request_parms);
    //---------------
    // set api parms
    //---------------
    let api_parms = {
      api_request: request,
      payload: this_reaction,
    };
    //----------
    // call api
    //----------
    this_store
      .dispatch("combat/editCombatReaction", api_parms)
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
